import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../../../core/auth/auth.service';

export const LoginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for initialization first - prevent rendering login page
  if (!authService.isInitialized()) {
    // During initialization, block navigation
    // The app template will show a loader
    return false;
  }

  // Check if user is authenticated using signal
  if (authService.isAuthenticated()) {
    // If already logged‐in, send them to their default "home" based on role
    router.navigate(['/companies']);
    authService.redirectUrl = null;
    return false;
  }

  return true; // allow /login (or /register) if not authenticated
};
